var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenEnergy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "#B9DCFF",
    stroke: "#B9DCFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0576 18.7979C14.0251 21.453 11.0159 22.7806 8.36076 21.748C5.76462 20.6565 4.46655 17.7063 5.4106 15.0512C6.64967 11.0684 10.9274 12.0125 12.904 7.11523C12.904 7.11523 17.3882 12.809 15.0576 18.7979Z",
    stroke: "url(#paint0_linear)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8135 7.11523C28.8939 7.11523 34.6467 12.868 34.6172 19.9484C34.6172 27.0288 28.8644 32.7816 21.784 32.7521C14.7036 32.7521 8.95084 26.9993 8.98034 19.9189C8.98034 17.8833 9.45236 15.8772 10.3964 14.0776C10.3964 14.0776 10.7209 13.1926 11.5765 12.1895",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38721 16.4082L9.00979 19.3879L11.6649 17.3228",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.82057,
    y1: 14.6011,
    x2: 16.0278,
    y2: 14.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA0029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CB9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27.8974,
    fill: "white",
    transform: "translate(4 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEnergy);
export default __webpack_public_path__ + "static/media/GreenEnergy.3e62b467.svg";
export { ForwardRef as ReactComponent };